export const theme = {
  color: {
    white: "#FFFFFF",
    whisper: "#F5F5FA", //light gray
    mystic: "#E4E6F0", //a bit darker light gray
    silver: "#C4C4C4",
    waterloo: "#7E839A", //darker gray with note of blue
    stormGray: "#74788B", //dark gray
    woodSmoke: "#18181B",
    blackPearl: "#03121F",
    black: "#000000",
    pattensBlue: "#D6E4FF",
    scienceBlue: "#0044CC",
    darkGray: "#333333",
  },
  breakpoint: {
    smallMobileMax: 319,
    mobileMax: 510,
    largeMobileMax: 767,
    tabletVerticalMax: 991,
    tabletHorizontalMax: 1199,
    laptopMax: 1400,
  },
};
